/*
  HYDY cart runtime: the cart drawer on Shopify's Ajax Cart API, replacing Instant's cart (2026-10-09).

  window.HYDY.cart
    add(items, { open, button })  POST /cart/add.js, then re-render the drawer; open it unless open === false
    change(key, quantity)         POST /cart/change.js for one line (0 removes it)
    open(trigger) / close() / toggle(bool)
    refresh()                     re-render the drawer from the server
  Every change dispatches `hydy:cart-updated` on document with { detail: cart }.

  The drawer is the `hy-cart` section. Its markup keeps the contract the Instant version had:
    [data-cart-overlay] with data-state="open|closed", [data-cart-close] closes it,
    each [data-cart-update="name"] is replaced from a fresh render after every change,
    [data-cart-minus|plus|remove] + data-line-key and input[data-cart-quantity] change a line.
*/
(function () {
  if (window.HYDY && window.HYDY.cart) return;
  var HYDY = (window.HYDY = window.HYDY || {});
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SECTION = 'hy-cart';
  var busy = false;
  var opener = null;

  function overlay() { return document.querySelector('[data-cart-overlay]'); }
  function errorBox() { var ov = overlay(); return ov && ov.querySelector('[data-hy-err]'); }
  function fail(msg) { var e = errorBox(); if (e) e.textContent = msg || ''; }

  function json(url, body) {
    return fetch(ROOT + url, {
      method: body ? 'POST' : 'GET',
      cache: 'no-store',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Não foi possível atualizar o carrinho.');
        return data;
      });
    });
  }

  /* Replace each [data-cart-update] region with the server's fresh render; the overlay and its listeners stay. */
  function render(html) {
    var ov = overlay();
    if (!ov || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    Array.prototype.forEach.call(ov.querySelectorAll('[data-cart-update]'), function (region) {
      var fresh = doc.querySelector('[data-cart-update="' + region.getAttribute('data-cart-update') + '"]');
      if (fresh) region.innerHTML = fresh.innerHTML;
    });
  }

  function refresh() {
    return Promise.all([
      /* no-store: a cached render showed the drawer empty right after an add (13/10) */
      fetch(ROOT + '?section_id=' + SECTION, { cache: 'no-store' }).then(function (r) { return r.text(); }),
      json('cart.js')
    ]).then(function (res) {
      render(res[0]);
      document.dispatchEvent(new CustomEvent('hydy:cart-updated', { detail: res[1] }));
      return res[1];
    });
  }

  function setState(open) {
    var ov = overlay();
    if (!ov) { if (open) window.location.href = ROOT + 'cart'; return; }
    var was = ov.getAttribute('data-state') === 'open';
    if (was === open) return;
    ov.setAttribute('data-state', open ? 'open' : 'closed');
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) {
      setTimeout(function () { var x = ov.querySelector('.hy-cart-x'); if (x) x.focus(); }, 60);
    } else if (opener && opener.focus && opener.isConnected) {
      opener.focus();
      opener = null;
    }
  }

  function add(items, opts) {
    opts = opts || {};
    var btn = opts.button;
    if (busy) return Promise.resolve({ success: false });
    busy = true;
    fail('');
    if (btn) btn.setAttribute('aria-busy', 'true');
    return json('cart/add.js', { items: items })
      .then(function () { return refresh(); })
      .then(function (cart) {
        if (opts.open !== false) { opener = btn || document.activeElement; setState(true); }
        return { success: true, cart: cart };
      })
      .catch(function (err) {
        fail(err.message);
        if (opts.open !== false) setState(true);
        return { success: false, error: err.message };
      })
      .then(function (r) { busy = false; if (btn) btn.removeAttribute('aria-busy'); return r; });
  }

  function change(key, quantity) {
    if (busy) return Promise.resolve();
    busy = true;
    fail('');
    var ov = overlay();
    if (ov) ov.setAttribute('aria-busy', 'true');
    return json('cart/change.js', { id: key, quantity: Math.max(0, quantity) })
      .then(function () { return refresh(); })
      .catch(function (err) { fail(err.message); })
      .then(function () { busy = false; if (ov) ov.removeAttribute('aria-busy'); });
  }

  /* Drawer controls, delegated on document so they survive every re-render. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var open = t.closest('[data-cart-open]');
    if (open) { if (e.defaultPrevented) return; e.preventDefault(); opener = open; setState(true); return; }
    if (t.closest('[data-cart-close]')) { e.preventDefault(); setState(false); return; }
    var ctl = t.closest('[data-cart-minus],[data-cart-plus],[data-cart-remove]');
    if (!ctl) return;
    e.preventDefault();
    var key = ctl.getAttribute('data-line-key');
    var input = document.querySelector('input[data-cart-quantity][data-line-key="' + key + '"]');
    var qty = input ? parseInt(input.value, 10) || 0 : parseInt(ctl.getAttribute('data-quantity'), 10) || 0;
    if (ctl.hasAttribute('data-cart-remove')) change(key, 0);
    else change(key, ctl.hasAttribute('data-cart-plus') ? qty + 1 : qty - 1);
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('input[data-cart-quantity]');
    if (input) change(input.getAttribute('data-line-key'), parseInt(input.value, 10) || 0);
  });
  document.addEventListener('keydown', function (e) {
    var ov = overlay();
    if (!ov || ov.getAttribute('data-state') !== 'open') return;
    if (e.key === 'Escape') { setState(false); return; }
    if (e.key !== 'Tab') return;
    var panel = ov.querySelector('[data-hy-cart]') || ov;
    var f = Array.prototype.slice.call(panel.querySelectorAll('a[href]:not([aria-disabled=true]),button:not([disabled]),input'))
      .filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });

  /* ?carrinho=aberto opens the drawer on load (the theme's /cart template and checkout's "back to cart" land here). */
  document.addEventListener('DOMContentLoaded', function () {
    var params = new URLSearchParams(window.location.search);
    if (params.get('carrinho') !== 'aberto') return;
    params.delete('carrinho');
    var qs = params.toString();
    if (history.replaceState) history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
    setState(true);
  });

  HYDY.cart = {
    add: add,
    change: change,
    refresh: refresh,
    open: function (trigger) { opener = trigger || document.activeElement; setState(true); },
    close: function () { setState(false); },
    toggle: function (on) { setState(on === undefined ? overlay().getAttribute('data-state') !== 'open' : !!on); }
  };
  HYDY.openCart = HYDY.cart.open;
})();
